import React from "react";
import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Paper,
  Slide,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon} from "@hugeicons/core-free-icons";

export const FilterDrawer = ({ open, onClose, filters, setFilters, onApply, onClear }) => {
  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <Slide in={open} direction="left">
      <Paper
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          width: 400,
          height: "100dvh",
          zIndex: 1300,
          boxShadow: 3,
          p: 3,
          overflowY: "auto",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h6" fontWeight={600}>
            Filter Annotations
          </Typography>
          <IconButton onClick={onClose}>
              <HugeiconsIcon icon={Cancel01Icon} />
          </IconButton>
        </Box>

        <Stack spacing={2}>
          <TextField
            label="Message ID"
            size="small"
            fullWidth
            value={filters.messageId || ""}
            onChange={(e) => handleChange("messageId", e.target.value)}
          />
          <TextField
            label="Conversation ID"
            size="small"
            fullWidth
            value={filters.conversationId || ""}
            onChange={(e) => handleChange("conversationId", e.target.value)}
          />
          <TextField
            label="Annotated Text"
            size="small"
            fullWidth
            value={filters.annotatedText || ""}
            onChange={(e) => handleChange("annotatedText", e.target.value)}
          />

          <FormControlLabel
            control={
              <Switch
                checked={filters.showOnlyUnresolved || false}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setFilters((prev) => ({
                    ...prev,
                    showOnlyUnresolved: isChecked,
                    resolved: isChecked ? false : null,
                  }));
                }}
                color="primary"
              />
            }
            label="Show only unresolved"
          />

          <TextField
            label="Start Date"
            type="datetime-local"
            size="small"
            fullWidth
            value={filters.startDate || ""}
            onChange={(e) => handleChange("startDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            type="datetime-local"
            size="small"
            fullWidth
            value={filters.endDate || ""}
            onChange={(e) => handleChange("endDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
            <Button variant="ghost" color={"secondary"} fullWidth onClick={onClear}>
              Clear
            </Button>
            <Button variant="modal" color={"secondary"} fullWidth onClick={onApply} sx={{ boxShadow: 0 }}>
              Apply
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Slide>
  );
};
